import { Field } from '../PreviewFields';
import { PreviewHeader } from '../PreviewHeader';
import { AadhaarCardMock } from './AadhaarCardMock';

// DigiLocker-based Aadhaar verification (the "without PIN" / "with PIN" options).
// Same form layout as the PAN screen; card + content changed. `withPin` only
// tweaks the helper copy — both redirect to DigiLocker to complete.
export function AadhaarDigilockerScreen({ withPin }: { withPin?: boolean }) {
  return (
    <>
      <PreviewHeader title="Aadhaar Verification" subtitle="Verify your Aadhaar" />

      <div className="mb-2 w-full">
        <AadhaarCardMock />
      </div>

      {/* ONE field, the mobile number — nothing else.
          There used to be an "Aadhaar Number" input above this. It was wrong: both
          DigiLocker methods (with PIN and without) take only the linked mobile
          number, which is exactly what AadhaarStepRunner asks for in the real run,
          and what the applicant is shown before being sent to DigiLocker. Asking for
          the Aadhaar number here would have promised a field the flow never collects.
          It went unnoticed because these two methods had no preview screen wired up
          at all until now. */}
      {/* Optional on the WITH-PIN route: the applicant enters their Aadhaar number, OTP and
          PIN inside DigiLocker, so nothing here gates Continue. Required on PIN-LESS, where
          the number identifies the MeriPehchaan account being logged into. Mirrors
          AadhaarStepRunner so the preview and the real run agree. */}
      <Field
        label="Mobile Number Linked with Aadhaar"
        placeholder="98XXXXXX10"
        inputMode="numeric"
        optional={withPin}
        hint={withPin ? 'Optional — you can continue without it' : undefined}
      />

      <p className="mb-3 mt-2 text-[11px] leading-snug text-[#6B7280]">
        {withPin
          ? 'A secure verification window will open and ask for your Aadhaar OTP and security PIN.'
          : 'A secure verification window will open for you to log in and share your Aadhaar securely.'}
      </p>
    </>
  );
}
